var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.576 4.761a1.375 1.375 0 012.202-.357l3.818 3.818a1.375 1.375 0 01-.357 2.202l-4.393 2.196c-.367.184-.65.499-.795.883l-1.07 2.853-5.337-5.337 2.853-1.07c.384-.144.7-.428.883-.795l2.196-4.393zm3.086-1.24a2.625 2.625 0 00-4.204.681L6.262 8.595a.375.375 0 01-.204.183L3.169 9.862a1.225 1.225 0 00-.436 2.013l2.254 2.254-3.429 3.43a.625.625 0 00.884.883l3.429-3.43 2.254 2.255c.63.63 1.7.398 2.013-.436l1.084-2.889a.375.375 0 01.183-.204l4.393-2.196a2.625 2.625 0 00.682-4.204L12.662 3.52z"
  })));
}
export default SvgPin;